// extracted by mini-css-extract-plugin
module.exports = {"avatar":"RightPanel_avatar__2_QHo","avatarSmall":"RightPanel_avatarSmall__2Pgbw","customTooltip":"RightPanel_customTooltip__3_OHx"};